import React from 'react';

import { Button, notification } from 'antd';
import { formatMessage } from 'umi';

import appInsightsService from '@/utils/appInsights';
import defaultSettings from '../config/defaultSettings';

const { pwa } = defaultSettings; // if pwa is true

appInsightsService.initialize();

const SW_UPDATED_NOTIFICATION_KEY = 'sw-updated';

if (pwa) {
  // Never reload on its own: the user may be halfway through a form.
  window.addEventListener('sw.updated', (event) => {
    const worker = event.detail && event.detail.waiting;
    if (!worker) return;

    const refresh = () => {
      notification.close(SW_UPDATED_NOTIFICATION_KEY);
      try {
        worker.postMessage({ type: 'skip-waiting' });
      } catch (_) {
        /* the worker may already be active */
      }
      window.location.reload();
    };

    notification.info({
      key: SW_UPDATED_NOTIFICATION_KEY,
      message: formatMessage({ id: 'app.pwa.serviceworker.updated' }),
      description: formatMessage({ id: 'app.pwa.serviceworker.updated.hint' }),
      duration: 0,
      btn: (
        <Button type="primary" size="small" onClick={refresh}>
          {formatMessage({ id: 'app.pwa.serviceworker.updated.ok' })}
        </Button>
      ),
    });
  });
} else if ('serviceWorker' in navigator) {
  // unregister service worker
  const { serviceWorker } = navigator;

  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }

  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  }); // remove all caches

  if (window.caches && window.caches.keys) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
      });
    });
  }
}
